import { Dropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { accountService } from "../../services/accountService";
import LogicContext from "../../Context/LogicContext";
import { useEffect, useState, useContext, useRef } from "react";

import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { SetChartAccountData, GetChartAccountData } from "../../store/chartOfAccountAtom";
import Tooltip from "@mui/material/Tooltip";
import ChartOfAccountTable from "./ChartOfAccountTable";
import ChartOfAccountOptions from "./ChartOfAccountOptions";
import DelgroProgressBar from "../../generals/DelgroProgressBar";

const ChartOfAccountPage = () => {
  const logicContext = useContext(LogicContext);
  const setChartAccountData = SetChartAccountData();
  const getChartAccountData = GetChartAccountData();

  const myPromiseModal = createModal(GeneralModal);

  const [itemSelected, setItemSelected] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();

  const { pathname } = useLocation();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const isMounted = useRef(false);

  const loadTableData = () => {
    accountService.getChartOfAccount().then((res) => {
      if (isMounted.current && res?.data !== undefined) {
        setItemSelected([]);
        setChartAccountData(res.data);
      }
    });
  };

  useEffect(() => {
    isMounted.current = true;
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      loadTableData();
    }

    if (getChartAccountData?.chart_of_accounts?.length < 1) {
      loadTableData();
    } else {
      setTableData(getChartAccountData?.chart_of_accounts);
    }
    return () => {
      isMounted.current = false;
    };
  }, [getChartAccountData?.chart_of_accounts]);

  function selectedTableItems(itemKeysIds) {
    setItemSelected(itemKeysIds);
  }

  const resetSelectedItems = () => {
    setItemSelected([]);
  };

  const onFilterSelect = (option) => {
    if (option?.Filtering_Name === "All Accounts") {
      return setTableData(getChartAccountData.chart_of_accounts);
    }

    const newList = getChartAccountData.chart_of_accounts?.filter(
      (acc) => acc[option?.Filtering_Field_Name] == option?.Filtering_Field_Value
    );
    setTableData(newList);
  };

  async function bulkActions(message, option) {
    await myPromiseModal({
      title: `${message}?`,
      body: `Do you want to ${message}?`,
      showInput: false,
      placeHolder: "",
    }).then((result) => {
      if (result.decision === true) {
        const xml_string = `<root>${itemSelected
          .map((accountId) => `<a><account_id>${accountId}</account_id></a>`)
          .join("")}</root>`;
        accountService
          .updateAccountStatus({ xml_string, option })
          .then((res) => {
            if (res?.data !== undefined) {
              const { message_text } = res.data[0];
              logicContext.showToast(message_text, "success");
              loadTableData();
            }
          })
          .catch((err) => {
            logicContext.showToast("Error", "error");
          });
      }
    });
  }

  const onItemSelect = (selection) => {
    // navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${selection?.original?.Account_Id}`)
  };

  return (
    <>
      {!getChartAccountData?.filtering_criteria && <DelgroProgressBar />}

      {itemSelected?.length > 0 ? (
        <div className="row">
          <div className="col col-md-4">
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  backgroundColor: "#E5E5E5",
                  border: "none",
                  color: "#45444B",
                  fontSize: "12px",
                  height: "45px",
                }}
                id="dropdown-basic"
              >
                Bulk Actions
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => bulkActions("Mark selection(s) as Active", 4)}
                >
                  Mark as Active
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() =>
                    bulkActions("Mark selection(s) as InActive", 5)
                  }
                >
                  Mark as InActive
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => bulkActions("Delete selection(s)", 3)}
                >
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="col col-md-4 offset-md-4 text-center">
            <button onClick={resetSelectedItems} className="btn btn-danger">
              X
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-2 flex items-center justify-between">
          <div className="flex items-center gap-3 shrink-0">
            <ChartOfAccountOptions
              list={getChartAccountData?.filtering_criteria}
              onFilterSelect={onFilterSelect}
            />
            <Tooltip title="Reload">
              <button
                onClick={loadTableData}
                className="h-fit w-fit text-blue-600 hover:text-blue-800 shrink-0 transition-colors p-1.5 rounded-full bg-gray-200 hover:bg-gray-100 active:rotate-12 active:bg-gray-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>

                {/* <RestartAltIcon fontSize="medium" /> */}
              </button>
            </Tooltip>
          </div>

          <div className="">
            <Tooltip title="Add New Account">
              <Link
                to={`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`}
              >
                <button className="bg-blue-600 hover:bg-blue-700 flex flex-row items-center text-sm font-medium px-3 py-2 rounded-md transition-colors">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-4 text-white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4.5v15m7.5-7.5h-15"
                      />
                    </svg>
                  </span>{" "}
                  <span className="ml-1 text-white"> Add New</span>
                </button>
              </Link>
            </Tooltip>
          </div>
        </div>
      )}

      <section className="mt-8 w-full z-10">
        <ChartOfAccountTable
          tableData={tableData}
          onItemSelect={onItemSelect}
          selectedTableItems={selectedTableItems}
        />
      </section>
    </>
  );
};

export default ChartOfAccountPage;
